import get from 'lodash/get';

export const NEEDS_UNLOCK_DIALOG = 'NEEDS_UNLOCK_DIALOG';
export const UNLOCK_SUCCESS = 'UNLOCK_SUCCESS';
export const UNLOCK_FAILURE = 'UNLOCK_FAILURE';
export const UNLOCK_CREDIT = 'UNLOCK_CREDIT';
export const UNLOCK_CLOSED = 'UNLOCK_CLOSED';
export const UNLOCK_UPDATE_DIALOG_DIMENSIONS =
  'UNLOCK_UPDATE_DIALOG_DIMENSIONS';

function unlockEffect({ type, args, meta, transform }) {
  return {
    type,
    api: {
      endpoint: ['auth', 'premiumUnlock'],
      args,
      transform,
    },
    meta,
  };
}

// Used for showing the unlock dialog
export function needsUnlockDialog(params) {
  return {
    type: NEEDS_UNLOCK_DIALOG,
    campaignId: get(params, 'campaignId'),
    campaignKey: get(params, 'campaignKey'),
    unlockToken: get(params, 'unlockToken'),
  };
}

// Used for when the user has successfully unlocked
export function unlockSuccess() {
  return {
    type: UNLOCK_SUCCESS,
  };
}

export function unlockCredit(unlockParams) {
  return (dispatch) =>
    dispatch(
      unlockEffect({
        type: UNLOCK_CREDIT,
        args: [unlockParams],
        transform: (response) => {
          let value = {};
          try {
            value = response.data.body[0];
        } catch (e) { //eslint-disable-line
            // no-op
          }
          return value;
        },
      }),
    );
}

// Used for when the user failed to unlock
export function unlockFailure() {
  return {
    type: UNLOCK_FAILURE,
  };
}

// Used for closing the unlock dialog.
export function unlockClosed() {
  return {
    type: UNLOCK_CLOSED,
  };
}

export function updateUnlockDialogDimensions(width, height) {
  return {
    type: UNLOCK_UPDATE_DIALOG_DIMENSIONS,
    width,
    height,
  };
}
